import BezierEasing from 'bezier-easing'

const active = false

/**
 * Scroll
 */
const scroll = {}

scroll.started = false
scroll.current = 0
scroll.smoothed = 0
scroll.smoothedRounded = 0
scroll.time = Date.now()
scroll.delta = 16
scroll.progress = 0
scroll.height = 600
scroll.windowHeight = 600

scroll.animation = {}
scroll.animation.running = false
scroll.animation.startValue = 0
scroll.animation.endValue = 0
scroll.animation.startTime = 0
scroll.animation.duration = 0
scroll.animation.progress = 0
scroll.animation.easing = BezierEasing(0.75, 0, 0.25, 1)

scroll.$container = null
scroll.$content = null
scroll.$dummy = null

const updateValues = () =>
{
    if(active && !scroll.animation.running)
    {
        scroll.smoothed += (scroll.current - scroll.smoothed) * 0.0075 * scroll.delta
    }
    else
    {
        scroll.smoothed = scroll.current
    }

    const smoothedRounded = Math.round(scroll.smoothed * 100) / 100
    const callCallbacks = smoothedRounded !== scroll.smoothedRounded

    scroll.smoothedRounded = smoothedRounded

    scroll.progress = scroll.smoothed / (scroll.height - scroll.windowHeight)

    if(isNaN(scroll.progress))
    {
        scroll.progress = 0
    }

    scroll.progress = Math.round(scroll.progress * 10000) / 10000

    // Update element
    if(active)
    {
        scroll.$content.style.transform = `translateY(${-scroll.smoothedRounded}px)`
    }

    // Call callbacks
    if(callCallbacks)
    {
        for(const _callback of callbacks)
        {
            _callback()
        }
    }
}

/**
 * Callbacks
 */
const callbacks = []

/**
 * RAF
 */
let time = Date.now()

const tickCallback = () =>
{
    window.requestAnimationFrame(tickCallback)

    // Time
    const newTime = Date.now()
    let delta = newTime - time
    time = newTime

    if(delta > 60)
    {
        delta = 60
    }

    // Animation
    if(scroll.animation.running)
    {
        scroll.animation.progress = (time - scroll.animation.startTime) / (scroll.animation.duration * 1000)

        if(scroll.animation.progress >= 1)
        {
            scroll.animation.progress = 1
            scroll.animation.running = false
            window.scrollTo(0, scroll.animation.endValue)
        }

        scroll.animation.easedProgress = scroll.animation.easing(scroll.animation.progress)

        const value = scroll.animation.startValue + (scroll.animation.endValue - scroll.animation.startValue) * scroll.animation.easedProgress
        scroll.current = value

        if(!active)
        {
            window.scrollTo(0, scroll.current)
        }
    }

    // // Update values
    // if(scroll.started && (active || scroll.animation.running))
    // {
    //     updateValues()
    // }
}

tickCallback()

// Scroll
const scrollCallback = () =>
{
    scroll.current = window.pageYOffset || document.documentElement.scrollTop

    if(!active)
    {
        updateValues()
    }
}

window.addEventListener('scroll', scrollCallback, { passive: true })
scrollCallback()

// // Resize
// const resizeCallback = () =>
// {
//     scroll.height = scroll.$content.offsetHeight
//     scroll.windowHeight = window.innerHeight

//     if(active)
//     {
//         scroll.$dummy.style.height = `${scroll.height}px`
//     }
// }

// window.addEventListener('resize', resizeCallback)

/**
 * Mixin
 */
export default {
    data: function()
    {
        return {
            scroll
        }
    },

    created: function()
    {
        // Save callbacks
        callbacks.push(this.onScroll)
    },

    mounted: function()
    {
        if(!scroll.started)
        {
            // scroll.$container = document.querySelector('.js-scroll-container')
            // scroll.$content = scroll.$container.querySelector('.js-scroll-content')
            // scroll.$dummy = document.querySelector('.js-scroll-dummy')

            if(active)
            {
                scroll.$container.classList.add('active')
            }

            if(scroll.$content)
            {
                resizeCallback()
                scroll.started = true
            }
        }
    },

    destroyed: function()
    {
        // Delete callbacks
        callbacks.splice(callbacks.findIndex((_item) => _item === this.onScroll), 1)
    },

    methods:
    {
        onScroll: function()
        {

        },

        updateScrollHeight: function()
        {
            scroll.height = scroll.$content.offsetHeight

            if(active)
            {
                scroll.$dummy.style.height = `${scroll.height}px`
            }
        },

        scrollTo: function(value = 0, force = false)
        {
            window.scrollTo(0, value)

            if(force)
            {
                this.scroll.current = value
                this.scroll.smoothed = value
            }
        },

        animateTo: function(value = 0, duration = 2)
        {
            scroll.animation.startValue = this.scroll.current
            scroll.animation.endValue = value

            // Value didn't change
            if(scroll.animation.startValue === scroll.animation.endValue)
            {
                return
            }

            scroll.animation.startTime = Date.now()
            scroll.animation.running = true
            scroll.animation.duration = duration
            scroll.animation.progress = 0
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/Scroll.js